import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData_Jupiter from "../NoData_Jupiter";
import ChartLoader_Jupiter from "../ChartLoader_Jupiter";
import BuketsTableVehicle_Jupiter from "../BuketsTableVehicle_Jupiter";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../DashboardMain_Jupiter/WaterMark";
import { BsZoomIn } from "react-icons/bs";

import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result

export default function MaxBatteryTempVehicleLevel_Jupiter({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [check, SetCheck] = useState("slow");
  const [chartname, SetChartName] = useState("Max HV battery temp - Slow chrg");
  let barcolor
  let modal_title = "Max HV Battery Temp Slow Charge";
  let toPush = [];
  const appyData = (data) => {
    res_result = data;

    let responce = {
      "<26": 0,
      "28": 0,
      "30": 0,
      "32": 0,
      "34": 0,
      "36": 0,
      "38": 0,
      "40": 0,
      "42": 0,
      ">=42": 0
    };
    if (res_result.length === 0) {
      setChartData((prestate) => []);
    }
    if (res_result.length != 0) {


      let t_val = res_result[0];

      if (t_val.doc_count != 0) {
        if (t_val.less22.value > 0)
          responce["<26"] = t_val.less22.value
        if (t_val.less26_28.value > 0)
          responce["28"] = t_val.less26_28.value
        if (t_val.less28_30.value > 0)
          responce["30"] = t_val.less28_30.value
        if (t_val.less30_32.value > 0)
          responce["32"] = t_val.less30_32.value
        if (t_val.less32_34.value > 0)
          responce["34"] = t_val.less32_34.value
        if (t_val.less34_36.value > 0)
          responce["36"] = t_val.less34_36.value
        if (t_val.less36_38.value > 0)
          responce["38"] = t_val.less36_38.value
        if (t_val.less38_40.value > 0)
          responce["40"] = t_val.less38_40.value
        if (t_val.less40_42.value > 0)
          responce["42"] = t_val.less40_42.value
        if (t_val.greater_42.value > 0)
          responce[">=42"] = t_val.greater_42.value

        toPush.push(t_val.less22.value)
        toPush.push(t_val.less26_28.value)
        toPush.push(t_val.less28_30.value)
        toPush.push(t_val.less30_32.value)
        toPush.push(t_val.less32_34.value)
        toPush.push(t_val.less34_36.value)
        toPush.push(t_val.less36_38.value)
        toPush.push(t_val.less38_40.value)
        toPush.push(t_val.less40_42.value)
        toPush.push(t_val.greater_42.value)
        SetfilteredData(toPush)

        let res_result_final = [["Element", "Count", { role: "style" }]]
        let loop_keys = Object.keys(responce);

        loop_keys = ["<26", "28", "30", "32", "34", "36", "38", "40", "42", ">=42"]
        const labels = ["<26", "28", "30", "32", "34", "36", "38", "40", "42", ">=42"]

        Maxchartdata = {
          labels,
          datasets: [
            {
              label: "Max Battery temp (oC)",
              data: responce,
              backgroundColor: barcolor,
              borderWidth: 1,
              borderColor: "black",
            },
          ]
        };
        let countcheck = 0
        for (const key in responce) {
          if (responce[key] > 0) {
            countcheck = countcheck + 1
          }
        }
        loop_keys.map(x => {
          if (countcheck)
            res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${barcolor}}`]);
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }

  let hAxis = {};

  if (apiend == "rangebarchart") {
    modal_title = "Real World Range Distribution";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Range (Km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  if (apiend == "energybarchart") {
    modal_title = "Net Energy consumption";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Wh / Km',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Max Battery temp (oC)'
        },
        suggestedMin: 0,
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycles'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Max Battery temp (oC)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
  };

  useEffect(() => {
    if (type === "Slow") {
      fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/maxbatterytempVehiclelevelslow", body: { filterdata: gloablfilter } }, appyData)
      SetChartName("Max HV battery temp - Slow chrg")
      SetCheck("slow")
      barcolor = "#348393"
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/maxbatterytempVehiclelevelfast", body: { filterdata: gloablfilter } }, appyData)
      SetChartName("Max HV battery temp - Fast chrg")
      barcolor = "#FFA650"
    }
  }, [gloablfilter, type])

  const appyDataClick = (data) => {
    let hits = data;
    hits.map((i, key) => {
      toPush.push(i.fields.BMS_Max_Cell_Temp[0])
    })
    SetfilteredData(toPush.sort())
  }

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData_Jupiter />
                )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <WaterMark />
      {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
        {
          eventName: "select",
          callback({ chartWrapper }) {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            const [selectedItem] = selection;
            const { row } = selectedItem;
            const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
            let from_bucket;
            let to_bucket;
            const count = chartWrapper.getDataTable().Wf[row].c[1].v;

            if (count !== 0) {
              if (barvalue === "<26") {
                from_bucket = 0
                to_bucket = 26
              } else if (barvalue === ">=42") {
                from_bucket = 42
                to_bucket = null
              } else {
                from_bucket = barvalue - 2
                to_bucket = barvalue
              }
              if (type === "Slow")
                fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/max_battery_vehicle_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
              else
                fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/max_battery_vehicle_click_fast", body: { filterdata: gloablfilter, type: "fast", from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
              window.$('#exampleModal__' + apiend).modal('show');
            }
          }
        }
      ]}
      /> : <NoData_Jupiter />)}


      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BuketsTableVehicle_Jupiter data={filteredData} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

